<template>
  <article class="sale-summary-card sale-summary-card--financial sale-summary-card--incomes-progress">
    <header class="sale-summary-card__header">
      <div>
        <h4>{{ text.title }}</h4>
        <p>{{ text.subtitle }}</p>
      </div>

      <span class="sale-summary-pill" :class="incomeStatus.className">{{ incomeStatus.label }}</span>
    </header>

    <div class="sale-summary-progress">
      <div class="sale-summary-progress__head">
        <span>{{ text.progressLabel }}</span>
        <strong>{{ revenueProgressLabel }}</strong>
      </div>

      <div class="sale-summary-progress__track" role="progressbar" :aria-valuenow="revenueProgressPercent" aria-valuemin="0" aria-valuemax="100">
        <div class="sale-summary-progress__fill is-income" :style="revenueProgressStyle"></div>
      </div>
    </div>

    <div class="sale-summary-kpis">
      <div class="sale-summary-kpi-box">
        <span>{{ text.kpis.target }}</span>
        <strong>{{ formatMoney(revenueTargetAmount) }}</strong>
      </div>
      <div class="sale-summary-kpi-box">
        <span>{{ text.kpis.collected }}</span>
        <strong>{{ formatMoney(revenueCollectedAmount) }}</strong>
      </div>
      <div class="sale-summary-kpi-box">
        <span>{{ text.kpis.pending }}</span>
        <strong class="sale-summary-kpi-box__highlight">{{ formatMoney(revenuePendingAmount) }}</strong>
      </div>
    </div>
  </article>
</template>

<script>
import { SALES_TEXT } from '@/texts/catalog/sales';
import { formatCurrency } from '@/utils/numberFormat';

const INCOME_CARD_TEXT = SALES_TEXT.shared.summary.incomeCard;

export default {
  name: 'SaleSummaryIncomeProgressCard',
  props: {
    revenueTargetAmount: {
      type: Number,
      default: 0,
    },
    revenueCollectedAmount: {
      type: Number,
      default: 0,
    },
    revenuePendingAmount: {
      type: Number,
      default: 0,
    },
    revenueProgressPercent: {
      type: Number,
      default: 0,
    },
    revenueProgressPercentRaw: {
      type: Number,
      default: 0,
    },
    incomeStatus: {
      type: Object,
      default: () => ({ label: INCOME_CARD_TEXT.defaults.statusLabel, className: 'is-danger' }),
    },
  },
  data() {
    return {
      text: INCOME_CARD_TEXT,
    };
  },
  computed: {
    revenueProgressLabel() {
      return `${Number(this.revenueProgressPercentRaw || 0).toFixed(1)}%`;
    },
    revenueProgressStyle() {
      return {
        width: `${Number(this.revenueProgressPercent || 0)}%`,
        background: this.revenueProgressBackground,
      };
    },
    revenueProgressBackground() {
      const start = { r: 37, g: 99, b: 235 };
      const end = { r: 22, g: 163, b: 74 };
      const ratio = Math.max(0, Math.min(1, Number(this.revenueProgressPercent || 0) / 100));

      const r = Math.trunc(start.r + ((end.r - start.r) * ratio));
      const g = Math.trunc(start.g + ((end.g - start.g) * ratio));
      const b = Math.trunc(start.b + ((end.b - start.b) * ratio));

      return `linear-gradient(90deg, #2563eb 0%, rgb(${r}, ${g}, ${b}) 100%)`;
    },
  },
  methods: {
    formatMoney(value) {
      return formatCurrency(value || 0);
    },
  },
};
</script>
